module.exports = __webpack_public_path__ + "static/media/arrow.d1704817.png";